import { createSelector, createSlice } from '@reduxjs/toolkit'
import { fetchInitContext } from './features/thunks'
import type { ThemeInitState } from './features/types'
import type { RootState } from './'

/* initial State */
const initialState: ThemeInitState = {
	primary: '#2d3338',
	secondary: '#c2561a',
	tertiary: '',
	color: '#363c42',
	textColor: '#363c42',
	fontStack: '"din-2014",Arial,sans-serif',
	fontBase: '14px',
	keyline: '7px',
	primaryBackground: '#c2561a',
	name: '',
	logo: '',
	textOnPrimary: '#ffffff',
	splashBackground: '',
	splashBackgroundSm: '',
	logoSymbol: '',
	header: {
		welcomeBand: false,
		userTab: true,
		background: 'inherit',
		color: '#333',
	},
	footer: {
		footer: false,
		OtherServicesBar: false,
		DashQuickLinks: true,
	},
	sidebar: {
		sidebarHeaderFooterColor: '#f2f2f2',
		sidebarMenuItemsColor: '#f2f2f2',
		sidebarTextColor: '#363c42',
		sidebarMainColor: 'white',
		sidebarFooterLogo: '',
	},
	loading: false,
}

export const themeSlice = createSlice({
	name: 'theme',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder.addCase(fetchInitContext.fulfilled, (state, action) => {
			const { theme } = action.payload
			if (theme) {
				state = theme
				state.loading = false
				return state
			}
			return state
		})
		builder.addCase(fetchInitContext.pending, state => {
			state.loading = true
		})
		builder.addCase(fetchInitContext.rejected, state => {
			state.loading = false
		})
	},
})
export const selectTheme = (state: RootState) => state.theme
export const selectThemeFooter = createSelector(selectTheme, theme => theme.footer)
export const selectThemeHeader = createSelector(selectTheme, theme => theme.header)
export const selectThemeSidebar = createSelector(selectTheme, theme => theme.sidebar)
